/* Carriely – merkstijl: aankondiging met pijltjes, menulade met open groepen */
(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Aankondigingsbalk: eigen wisselaar met vorige/volgende-pijltjes (vervangt de automatische wisselaar) */
  document.querySelectorAll('.announcement [data-rotator]').forEach((old) => {
    const rotator = old.cloneNode(true);
    rotator.removeAttribute('data-rotator');
    old.replaceWith(rotator);
    const msgs = Array.from(rotator.querySelectorAll('.announcement__msg'));
    if (msgs.length < 2) return;
    let i = Math.max(0, msgs.findIndex((m) => m.classList.contains('is-active')));
    const show = (n) => {
      msgs[i].classList.remove('is-active');
      i = (n + msgs.length) % msgs.length;
      msgs[i].classList.add('is-active');
    };
    const arrow = (dir) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = `ic-ann-arrow ic-ann-arrow--${dir < 0 ? 'prev' : 'next'}`;
      b.setAttribute('aria-label', dir < 0 ? 'Vorig bericht' : 'Volgend bericht');
      b.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="${dir < 0 ? 'm15 5-7 7 7 7' : 'm9 5 7 7-7 7'}"/></svg>`;
      b.addEventListener('click', () => { show(i + dir); restart(); });
      return b;
    };
    const wrap = document.createElement('div');
    wrap.className = 'ic-ann';
    rotator.before(wrap);
    wrap.append(arrow(-1), rotator, arrow(1));
    let timer;
    let paused = false;
    const restart = () => {
      clearInterval(timer);
      if (!reduced) timer = setInterval(() => { if (!paused && !document.hidden) show(i + 1); }, 5000);
    };
    wrap.addEventListener('mouseenter', () => { paused = true; });
    wrap.addEventListener('mouseleave', () => { paused = false; });
    restart();
  });

  /* Brede menulade: groepen staan open, zoals bij grote modewinkels */
  document.querySelectorAll('.drawer--wide .mnav details').forEach((d) => { d.open = true; });
})();
